import { useState, useEffect } from 'react'
import Layout from '../../layout'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { formateDate, capitalizeFirstLetter } from '../../helpers/commonFunctions';
import Sorting from '../../components/common/sorting';
import Loader from '../../components/common/loader'
import Breadcrums from '../../components/common/breadcrumbs'
import CustomPagination from '../../components/common/customPaginationAdmin'
import { GetOutletHardwares } from '../../services/outletManagementService'
import ViewAllDetails from './viewAllDetails'
import notFound from '../../assets/company/img/no-record-found.png'

const HARDWARE_LABELS = {
    pos: 'POS',
    kitchen: 'Kitchen',
    swipe_machine: 'Swipe Machine',
};

const HARDWARE_COLORS = {
    pos: 'bg-primary',
    kitchen: 'bg-warning text-dark',
    swipe_machine: 'bg-info',
};

const OutletHardwares = () => {

    const breadcrumbs = [{ title: "Dashboard", url: "/admin/dashboard" }, { title: "Companies", url: "/admin/company/list/1" }, { title: "Outlet Hardwares", url: "" }]
    const navigate = useNavigate()
    const params = useParams()
    const location = useLocation()
    const [list, setList] = useState([])
    const [dataLength, setDataLength] = useState()
    const [itemPerPage] = useState(10)
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true)
    const [search, setSearch] = useState({})
    const [globalSearch, setGlobalSearch] = useState("")

    const companyId = params.id;

    useEffect(() => {
        setLoader(true)
        const formData = new FormData()
        formData.append("page", params.pgno)
        formData.append("per_page", itemPerPage)
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append("company_id", companyId)
        GetOutletHardwares(formData).then(data => {
            setDataLength(data.data.response.count);
            setList(data?.data?.response?.rows || [])
            setLoader(false)
        }).catch(error => {
            console.log("error ====> ", error);
            setLoader(false)
        })
    }, [location, sorting, search, globalSearch])

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    }

    const viewFunction = (id) => {
        navigate(`/admin/outlet-hardwares/view/${id}?id=${companyId}`);
    }

    /* Renders the device-type-specific detail cell */
    const renderDeviceDetails = (row) => {
        if (row.hardware_used === 'pos') {
            return (
                <div style={{ fontSize: '0.82rem' }}>
                    {row.customer_printer_name && <div><span className="text-muted">Customer Printer:</span> {row.customer_printer_name} {row.customer_printer_ip ? `(${row.customer_printer_ip})` : ''}</div>}
                    {row.kitchen_printer_name && <div><span className="text-muted">Kitchen Printer:</span> {row.kitchen_printer_name} {row.kitchen_printer_ip ? `(${row.kitchen_printer_ip})` : ''}</div>}
                    {row.is_main_cashier && <span className="badge bg-success mt-1">Main Cashier</span>}
                </div>
            );
        }
        if (row.hardware_used === 'kitchen') {
            return (
                <div style={{ fontSize: '0.82rem' }}>
                    {row.kitchen_device_name && <div><span className="text-muted">Device:</span> {row.kitchen_device_name}</div>}
                    {row.kitchen_device_registration_id && <div><span className="text-muted">Reg ID:</span> {row.kitchen_device_registration_id}</div>}
                </div>
            );
        }
        if (row.hardware_used === 'swipe_machine') {
            return <span style={{ fontSize: '0.82rem' }}>{capitalizeFirstLetter(row.swipe_machine) || '—'}</span>;
        }
        return '—';
    }

    return (
        <Layout>
            <Breadcrums data={breadcrumbs} />
            <div className="animation_fade">
                <div className="card custom-card overflow-hidden">
                    <div className="card-body">
                        <ViewAllDetails tab='outlet-hardwares' />
                        <div className='d-flex justify-content-between align-items-center mb-4'>
                            <div className='d-flex align-items-center'>
                                <div className='form-group mb-0 me-3'>
                                    <div className="form-group mb-0 rangepicker_container">
                                        <i className="fa fa-search calender_icon"></i>
                                        <input type="search" className="form-control" value={globalSearch} placeholder="Search" onChange={(e) => { setGlobalSearch(e.target.value) }} />
                                    </div>
                                </div>
                                <button type="reset" value='Reset' onClick={() => { setGlobalSearch(""); setSearch({}); }} className="btn btn-warning float-right mr-2">Reset Filter</button>
                            </div>
                        </div>
                        <div className="tabler-wrap">
                            <div className="table-responsive">
                                <table className="table table-custom">
                                    <thead>
                                        <tr>
                                            <th width="12%">
                                                <div className='sorting_column'>
                                                    <span>Outlet</span>
                                                    <Sorting sort={sorting} handleSort={handleSort} column="outlet_id" />
                                                </div>
                                            </th>
                                            <th width="10%">Brand</th>
                                            <th width="9%">
                                                <div className='sorting_column'>
                                                    <span>Hardware</span>
                                                    <Sorting sort={sorting} handleSort={handleSort} column="hardware_used" />
                                                </div>
                                            </th>
                                            <th width="12%">Device Name</th>
                                            <th width="12%">Registration ID</th>
                                            <th width="18%">Details</th>
                                            <th width="10%">
                                                <div className='sorting_column'>
                                                    <span>Assigned Date</span>
                                                    <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="created_at" />
                                                </div>
                                            </th>
                                            <th width="8%">Status</th>
                                            <th className='action_head' width="9%">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loader ? (
                                            <tr><td colSpan={9}><Loader /></td></tr>
                                        ) : (
                                            <>
                                                {list.length ? list.map((row, i) => (
                                                    <tr key={row.id || i}>
                                                        <td>{capitalizeFirstLetter(row?.outlet?.outlet_name) || 'N/A'}</td>
                                                        <td>{capitalizeFirstLetter(row?.outlet?.brand?.name) || 'N/A'}</td>
                                                        <td>
                                                            <span className={`badge ${HARDWARE_COLORS[row.hardware_used] || 'bg-secondary'}`} style={{ fontSize: '0.78rem' }}>
                                                                {HARDWARE_LABELS[row.hardware_used] || row.hardware_used || 'N/A'}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {row.hardware_used === 'kitchen'
                                                                ? (row.kitchen_device_name || 'N/A')
                                                                : (row.name || 'N/A')
                                                            }
                                                        </td>
                                                        <td>
                                                            {row.hardware_used === 'kitchen'
                                                                ? (row.kitchen_device_registration_id || 'N/A')
                                                                : (row.registration_id || 'N/A')
                                                            }
                                                        </td>
                                                        <td>{renderDeviceDetails(row)}</td>
                                                        <td>{row.created_at ? formateDate(row.created_at) : 'N/A'}</td>
                                                        <td>
                                                            <span className={`badge ${row.status ? 'bg-success' : 'bg-secondary'}`}>
                                                                {row.status ? 'Active' : 'Inactive'}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <button className="btn ripple btn-main-primary signbtn" onClick={() => viewFunction(row.id)}>View</button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )) : (
                                                    <tr>
                                                        <td colSpan={9} className="text-center">
                                                            <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                            <p>No records</p>
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className='tabler-footer'>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <div id="example1_info" role="status" className="table-result" aria-live="polite">
                                        <b>Total Records : {dataLength || "0"}</b>
                                    </div>
                                    {dataLength && dataLength > 0 ?
                                        <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "device", path: `/admin/company/outlet-hardwares/${params.id}` }]} /> : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default OutletHardwares
